import React from "react";
import { formatDistance } from "date-fns";
import { LongTextLabel, VerticalDivider } from "@sscs/ui";
import styles from "./sharingStatusText.module.scss";

type SharingStatusTextProps = {
  sharedBy: string;
  purl: string;
  expirationDate: string;
};

const SharingStatusText = ({
  sharedBy,
  purl,
  expirationDate,
}: SharingStatusTextProps): React.JSX.Element => {
  return (
    <div className={styles["sharing-status-text"]}>
      <div className={styles["status-text"]}>
        Report{" "}
        {purl ? (
          <>
            for{" "}
            <LongTextLabel
              title={purl}
              label={purl}
              className={styles["purl"]}
            />
          </>
        ) : (
          ""
        )}{" "}
        has been shared by{" "}
        <LongTextLabel
          title={sharedBy ?? ""}
          label={sharedBy ?? ""}
          className={styles["shared-by"]}
        />
      </div>
      {expirationDate ? (
        <>
          <VerticalDivider />
          <div>
            Link expires{" "}
            <b>
              {formatDistance(new Date(expirationDate), new Date(), {
                addSuffix: true,
              })}
            </b>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default SharingStatusText;
